import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Lucie Aubin',
    description: 'Portfolio of Lucie Aubin, communication and marketing student: projects, experience, skills and contact.',
    url: getOrigin()
}
